import { Link } from 'react-router-dom';
import { TITLE } from '../data/portfolio';
import { useLang } from '../i18n';

const LABELS = { HOME: 'ACCUEIL', WORK: 'PROJETS', ABOUT: 'À PROPOS', CONTACT: 'CONTACT' };

export default function Footer() {
  const { lang } = useLang();
  const links = [
    ['HOME', '/'],
    ['WORK', '/work'],
    ['ABOUT', '/about'],
    ['CONTACT', '/contact'],
  ];
  return (
    <footer data-testid="footer" className="border-t border-ink/10 bg-paper">
      <div className="mx-auto max-w-[1600px] px-6 py-14 md:px-10 md:py-20">
        <div className="grid gap-10 md:grid-cols-2">
          <div className="space-y-3">
            <div className="text-sm font-medium uppercase tracking-[0.28em]">Donatien Grimaud</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-ink/60">{TITLE}</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-ink/50">Paris</div>
          </div>
          <div className="space-y-3 text-[11px] uppercase tracking-[0.22em] md:justify-self-end md:pr-10">
            <div className="text-ink/50">{lang === 'en' ? 'Navigation' : 'Navigation'}</div>
            {links.map(([n, to]) => (
              <Link key={n} to={to} data-testid={`footer-link-${n.toLowerCase()}`} className="block transition-colors hover:text-ink/60">
                {lang === 'en' ? n : LABELS[n]}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
